export let BiDataWidgetPlacement = /*#__PURE__*/function (BiDataWidgetPlacement) {
  BiDataWidgetPlacement["Header"] = "header";
  BiDataWidgetPlacement["Anchor"] = "anchor";
  BiDataWidgetPlacement["FullPage"] = "fullPage";
  BiDataWidgetPlacement["GFPP"] = "gfpp";
  return BiDataWidgetPlacement;
}({});
export function getWidgetPlacement(isFullWidth, isInvokedFromHeader) {
  if (isFullWidth) {
    return BiDataWidgetPlacement.FullPage;
  }
  return isInvokedFromHeader ? BiDataWidgetPlacement.Header : BiDataWidgetPlacement.Anchor;
}
//# sourceMappingURL=widgetPlacement.js.map